<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Upload Center Level Allocation Kit Data</p>
          </div>
        </div>
        <v-btn
          :to="{ name: 'kitAllocationListMapping' }"
          v-if="$vuetify.breakpoint.smAndUp"
          elevation="1"
          absolute
          right
          top
        >
          <v-icon left>mdi-arrow-left</v-icon>back
        </v-btn>
      </div>
    </section>
    <form
      @submit.prevent="onSubmit"
      enctype="multipart/form-data"
      name="saveKitAllocationData"
    >
      <card-component>
        <v-row>
          <v-col cols="12" md="4" lg="4" sm="4" xs="6">
            <div class="content">
              <b> .csv file must contain<br /></b>
              <ul>
                <li>
                  Franchisee ID: Creator needs to provide Franchisee ID and it
                  must be numeric.
                </li>
                <li>
                  Kit Name: Kit name needs to be provided and it must be valid.
                </li>
                <li>Class: Class is required and it must be valid.</li>
                <li>Set P1: Set P1 is required and must be valid.</li>
                <li>Set P2: Set P2 is required and must be valid.</li>
                <li>
                  Set P3 (Optional): It may be blank, if not then it must be
                  valid.
                </li>
              </ul>
            </div>
          </v-col>
          <v-col cols="12" md="4" lg="4" sm="4" xs="6">
            <b-field>
              <b-upload
                v-model="dropFiles"
                @input="csvToJsonInput(dropFiles)"
                accept=".csv"
                single
                drag-drop
                title="Please do upload .csv file only"
              >
                <section class="section">
                  <div class="content has-text-centered">
                    <p>
                      <b-icon icon="upload" size="is-large"> </b-icon>
                    </p>
                    <p>Drop your files here or click to upload</p>
                  </div>
                </section>
              </b-upload>
            </b-field>
            <div v-show="flag">
              <v-chip
                class="mt-1"
                color="indigo"
                text-color="white"
                @click:close="deleteDropFile"
                close
                label
              >
                {{
                  dropFiles !== null && dropFiles.name !== 'undefined'
                    ? dropFiles.name
                    : ''
                }}
              </v-chip>
            </div>
          </v-col>
          <v-col cols="12" md="4" lg="4" sm="4" xs="6">
            <div class="column has-text-centered">
              <a
                class="button is-link"
                href="https://intellitots.s3.ap-south-1.amazonaws.com/setFranchiseeMapping.csv"
                download
                >Download dummy file</a
              >
            </div>
          </v-col>
          <v-col cols="12" md="12" xs="12" lg="12" sm="12">
            <footer class="column has-text-centered">
              <button class="button is-success" type="submit">Upload</button>
            </footer>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" lg="12" sm="12" xs="12">
            <div class="columns is-mobile">
              <div
                class="column"
                v-if="resCountFlag"
                style="display: inline-block; margin-right: 5%"
              >
                <b-button
                  class="has-text-left"
                  outlined
                  type="is-success"
                  @click="exportToCSV('success')"
                  >Success: {{ resCount.success }} </b-button
                >&nbsp;
                <b-button
                  class="button has-text-centered"
                  outlined
                  type="is-info"
                  >Already Exist: {{ resCount.alreadyExist }}</b-button
                >&nbsp;
                <b-button
                  class="button has-text-right"
                  outlined
                  type="is-danger"
                  @click="exportToCSV('fail')"
                  >Failure: {{ resCount.failure }}</b-button
                >
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="12" lg="12" xs="12" sm="12">
            <v-data-table
              v-if="jsonData.length > 0"
              disable-pagination
              :hide-default-footer="true"
              :headers="jsonHeader"
              :items="jsonData"
              class="csv-custom-table"
            >
              <template v-slot:item.status="{ item }">
                <span
                  :class="
                    item.statusCode === 200
                      ? 'has-text-success'
                      : 'has-text-danger'
                  "
                  >{{ item.status }}
                </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </card-component>
    </form>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import csvtojsonV2 from 'csvtojson'
import ExportUtility from '@/utils/exportUtility'
import _ from 'lodash'

export default {
  name: 'uploadKitMapping',
  components: {
    CardComponent
  },
  props: ['kitType', 'setKitMapId'],

  data () {
    return {
      flag: '',
      jsonData: [],
      jsonHeader: [
        { text: 'Franchisee ID', value: 'franchiseeID' },
        { text: 'Kit Name', value: 'kitName' },
        { text: 'Class', value: 'class' },
        { text: 'Set P1', value: 'setP1' },
        { text: 'Set P2', value: 'setP2' },
        { text: 'Set P3', value: 'setP3' },
        { text: 'Status', value: 'status' }
      ],
      kitTypeVar: '',
      dropFiles: [],
      WowkitTypes: [],
      classID: '',
      classes: [],
      total: 0,
      paginated: false,
      kit: {},
      perPage: 10,
      loadingComponent: null,
      constantKit: _.filter(
        constants.KIT,
        (obj) => obj.isDisplayOnMapping === true
      ),
      fileinput: '',
      isResponse: false,
      academicYears: [],
      academicYear1: null,
      resCountFlag: false,
      resCount: {}
    }
  },
  created: function () {
    this.onStart()
    this.getAcademicYears()
  },
  watch: {
    kitType: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.onStart()
      }
    }
  },
  methods: {
    onStart: async function () {
      this.kit = _.find(this.constantKit, (item) =>
        _.isEqual(item.route, this.kitType)
      )
      if (_.isEmpty(this.kit)) {
        this.$router.push({
          name: 'listKitMapping',
          params: { kitType: this.constantKit[0].route }
        })
      }
      this.classes = []
      await this.getClassList()
    },
    getAcademicYears: async function () {
      try {
        const { data } = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears`
        )
        this.academicYears = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    dateFormat: function (i) {
      let j = i % 10
      let k = i % 100
      if (j === 1 && k !== 11) {
        return i + 'st'
      }
      if (j === 2 && k !== 12) {
        return i + 'nd'
      }
      if (j === 3 && k !== 13) {
        return i + 'rd'
      }
      return i + 'th'
    },
    getKitName: function (kitType) {
      return this.kit.name
    },
    readerFile: function (file, onLoadCallback) {
      let reader = new FileReader()
      reader.onload = onLoadCallback
      reader.readAsText(file)
    },
    resetHeaderArray: function () {
      return [
        { text: 'Franchisee ID', value: 'franchiseeID' },
        { text: 'Kit Name', value: 'kitName' },
        { text: 'Class', value: 'class' },
        { text: 'Set P1', value: 'setP1' },
        { text: 'Set P2', value: 'setP2' },
        { text: 'Set P3', value: 'setP3' }
      ]
    },
    csvToJsonInput: function (files) {
      if (files === null) {
        return this.$dialog.error({
          title: 'Error while choosing the file',
          text: 'Incorrect file format. Please upload .csv file'
        })
      } else {
        this.loadingComponent = this.$buefy.loading.open()
        this.isResponse = false
        this.resCountFlag = false
        this.resCount = {}
        let self = this
        if (files.length > 1) {
          this.dropFiles.splice(0, 1)
        }
        let file = files
        this.readerFile(file, async (e) => {
          try {
            this.jsonHeader = this.resetHeaderArray()
            self.jsonData = await csvtojsonV2().fromString(e.target.result)
            this.jsonData = self.jsonData
          } catch (e) {
            self.jsonData = 'this is not running'
          }
        })
        this.flag = true
        this.loadingComponent.close()
      }
    },
    deleteDropFile (index) {
      this.isResponse = false
      delete this.dropFiles.name
      this.jsonData = []
      this.dropFiles = []
      this.flag = false
      this.resCountFlag = false
      this.resCount = {}
      return this.dropFiles
    },

    getClassList: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()

        const classes = await http.get(
          `${constants.API_URL}/api/kits?kitType=${this.kit.id}`
        )
        this.loadingComponent.close()

        this.classes = classes.data.rows
        if (!this.classes[0].franchiseeModel && !this.classes[0].studentClass) {
          this.classID = this.classes[0].id
        }
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },

    async onSubmit (event) {
      this.$dialog.confirm({
        text: 'Do you really want to save?',
        title: 'Confirm',
        actions: {
          false: {
            text: 'Cancel',
            handle: () => {
              this.dropFiles = []
            }
          },
          true: {
            color: 'success',
            text: 'Ok',
            handle: async () => {
              this.hasClicked = true
              this.loader = true
              this.loadingComponent = this.$buefy.loading.open()
              /* Add Record */
              try {
                let payload = {}
                payload.kitSetFranchiseeMapList = this.jsonData
                await http
                  .post(
                    `${constants.API_URL}/api/kitSetMapping/kitSet-franchisee-mapping`,
                    payload
                  )
                  .then((res) => {
                    if (res.status === 200) {
                      if (res.data.response.length > 0) {
                        this.jsonHeader.push({
                          text: 'Status',
                          value: 'status'
                        })
                        this.jsonData = res.data.response
                        if (Object.keys(res.data.count).length > 0) {
                          this.resCountFlag = true
                          this.resCount = res.data.count
                        }
                      }
                    }
                  })
                this.loadingComponent.close()
                this.loader = false
              } catch (e) {
                this.loadingComponent.close()
                const errorTitle =
                  (e && e.response && e.response.data.error) || e.error
                const errorMessage =
                  (e && e.response && e.response.data.message) || e.message
                return this.$dialog.error({
                  title: errorTitle,
                  text: errorMessage
                })
              }
            }
          }
        }
      })
    },
    exportToCSV (type = '') {
      let csvData = []
      this.jsonData.forEach((item, index) => {
        if (type !== '' && type === 'success') {
          if (item.statusCode === 200) {
            csvData.push({
              franchiseeID: item.franchiseeID,
              kitName: item.kitName,
              class: item.class,
              setP1: item.setP1,
              setP2: item.setP2,
              setP3: item.setP3
            })
          }
        } else if (item.statusCode === 99) {
          csvData.push({
            franchiseeID: item.franchiseeID,
            kitName: item.kitName,
            class: item.class,
            setP1: item.setP1,
            setP2: item.setP2,
            setP3: item.setP3,
            status: item.status
          })
        }
      })
      ExportUtility.convertToCsv(csvData, 'kit_allocation')
    }
  }
}
</script>
<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
td {
  border: 1px dashed black;
  padding: 5px;
}
th {
  background: orange;
}
</style>
